// Hotel-Edition page "Marke" (PLAN.md §5.1 item 2, module 'marke', owner A). The brand kit moves here from the
// company profile, first entry under "Social Media Setup". Same card and APIs as before (/api/brand), so the
// Signal-Room brand sync keeps working unchanged. Reachable only with the module live (EditionModuleGate).
import BrandKitCard from "@/components/brand/BrandKitCard";

export const MARKE_DISABLED_TEXT = "Ihre Marke richtet Ihr Team für Sie ein. Bei Fragen wenden Sie sich an Ihr Team.";

export default function Marke() {
  return (
    <div className="container max-w-5xl mx-auto py-8 px-4 sm:px-6 lg:px-8 space-y-6" data-testid="page-marke">
      <div>
        <h1 className="text-3xl font-bold font-playfair">Marke</h1>
        <p className="text-muted-foreground mt-1">
          Logo, Farben, Schriften und Stil Ihres Hauses. Bisher im Firmenprofil, jetzt hier.
        </p>
      </div>
      {/* Never an empty page (Mike 2026-10-10): if the brand kit is off for this company, say who sets it up. */}
      <BrandKitCard whenDisabled={MARKE_DISABLED_TEXT} />
    </div>
  );
}
